export default __webpack_public_path__ + "static/media/Zelle-Symbol.8a234dec.png";